import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { FieldGroup, FieldGroupHeader } from '@/components/layout/field-table'

import { GeneralInfoGroup, isGeneralInfoGroupVisible } from './general-information.constants'

interface GeneralInformationGroupProps {
  children: ReactNode
  group: GeneralInfoGroup
  hiddenFields: string[]
  userRole: string | null
}

export const GeneralInformationGroup = ({
  children,
  group,
  hiddenFields,
  userRole,
}: GeneralInformationGroupProps) => {
  const { t } = useTranslation(['clients'])

  if (!isGeneralInfoGroupVisible(group, hiddenFields, userRole)) return null

  return (
    <FieldGroup>
      <FieldGroupHeader>{t(`clients:generalInformation.groups.${group}`)}</FieldGroupHeader>
      {children}
    </FieldGroup>
  )
}
